<template>
  <sfs-base-table
    :data-provider="$complianceDocumentsAPI.getComplianceDocuments"
    provider-key="complianceDocuments"
    :columns="columns"
    :filters="filters"
    :current-page="currentPage"
    :per-page="perPage"
    :show-per-page="showPerPage"
  >
    <template #cell(number)="data">
      <b-link :to="{ name: 'compliance-document', params: { id: data.item.id } }">
        {{ data.item.number }}
      </b-link>

      <div class="font-size-sm text-secondary">
        {{ data.item.category | humanizedFormat | capitalizeFormat }}
      </div>
    </template>
    <template #cell(status)="data">
      <status-badge
        :status="data.item.status"
        :status-variants="statusVariants"
        badge-class="font-size-sm mb-1"
      />
      <div class="font-size-sm text-secondary">
        {{ data.item.document_type | humanizedFormat | capitalizeFormat }}
      </div>
    </template>
    <template #cell(state)="data">
      {{ data.item.state || data.item.user.state }}
    </template>
    <template #cell(user_id)="data">
      <b-link :to="{ name: 'user', params: { id: data.item.user_id } }">
        {{ data.item.user?.name }}
      </b-link>
      <div v-if="data.item.user">
        <b-link
          class="font-size-sm text-secondary"
          :href="`mailto:${data.item.user.email}`"
        >
          {{ data.item.user.email }}
        </b-link>
      </div>
    </template>
    <template #cell(end_date)="data">
      <div class="mb-1">
        {{ data.item.current_coverage.end_date | dateFormat }}
      </div>
      <b-badge
        variant="success"
        class="font-size-sm"
        v-if="data.item.current_coverage.verified"
      >
        Verified
      </b-badge>
      <b-badge
        variant="secondary"
        class="font-size-sm"
        v-else
      >
        Not Verified
      </b-badge>
    </template>
    <template #cell(insurance_contact)="data">
      <div v-if="data.item.email">
        <b-link :href="`mailto:${data.item.email}`">
          {{ data.item.email }}
        </b-link>
      </div>
      <div v-if="data.item.phone">
        <b-link
          class="font-size-sm text-secondary"
          :href="`tel:${data.item.phone}`"
        >
          {{ data.item.phone }}
        </b-link>
      </div>
      <span />
    </template>
  </sfs-base-table>
</template>

<script>
import tablePropsMixin from '@/mixins/tablePropsMixin';
import { COMPLIANCE_DOCUMENT_STATUS_VARIANTS, COMPLIANCE_DOCUMENT_TABLE_DEFAULT_COLUMNS } from '@/constants/complianceDocuments';
import StatusBadge from '@/components/shared/StatusBadge.vue';

export default {
  name: 'ComplianceDocumentsTable',
  mixins: [tablePropsMixin],
  components: {
    StatusBadge,
  },
  props: {
    columns: {
      type: Array,
      default: () => COMPLIANCE_DOCUMENT_TABLE_DEFAULT_COLUMNS,
    },
  },
  data() {
    return {
      statusVariants: COMPLIANCE_DOCUMENT_STATUS_VARIANTS,
    };
  },
};
</script>
